module.exports = __webpack_public_path__ + "static/img/8b8b2c0d19717103896885d9d9671e4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/workflow_disable_05.png
// module id = HUSw
// module chunks = 1